unit AbfKontrolleEdit;

interface

uses System.SysUtils, System.Variants, System.Classes, Vcl.Graphics, Vcl.Controls,
     Vcl.Forms, Vcl.Dialogs, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent,
     VCL.TMSFNCBitmapContainer, WEBLib.Controls, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics,
     VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
     XData.Web.Client,  JS, Web, WEBLib.TreeNodes, Vcl.ComCtrls, WEBLib.ComCtrls, VCL.TMSFNCTreeViewBase, System.StrUtils,
     VCL.TMSFNCTreeViewData, VCL.TMSFNCCustomTreeView, VCL.TMSFNCTreeView, WEBLib.FlexControls,
     VCL.TMSFNCSignatureCapture;

[async] function DoAbfKontrolleEdit( var aID_AbfKon : Integer ) : TModalResult; async;


type
  TfrmAbfKontrolleEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbAbfKonCaption: TLabel;
    lbMitarbeiter: TLabel;
    btnAbbrechen: TTMSFNCToolBarButton;
    pnlFahrzeug: TPanel;
    edtZug: TEdit;
    WebLabel1: TLabel;
    edtAnh: TEdit;
    WebLabel2: TLabel;
    edtKmStand: TEdit;
    WebLabel3: TLabel;
    btnGetZugm: TTMSFNCToolBarButton;
    btnGetAnh: TTMSFNCToolBarButton;
    WebLabel4: TLabel;
    edtDatum: TDateTimePicker;
    pnlZusammenfassung: TPanel;
    btnNext: TTMSFNCToolBarButton;
    btnPrev: TTMSFNCToolBarButton;
    aTreeView: TTMSFNCTreeView;
    aBitmapContainerTreeView: TTMSFNCBitmapContainer;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    btnDelAnh: TTMSFNCToolBarButton;
    btnSpeichern: TTMSFNCToolBarButton;
    aUnterschrift: TTMSFNCSignatureCapture;
    WebLabel7: TLabel;
    lbMaengel: TLabel;
    WebLabel9: TLabel;
    optFahrbereit: TRadioButton;
    optNichtFahrbereit: TRadioButton;
    [async] procedure btnSpeichernClick(Sender: TObject); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnGetZugmClick(Sender: TObject); async;
    [async] procedure btnGetAnhClick(Sender: TObject); async;
    [async] procedure NodeEdit(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode; AColumn: Integer); async;
    [async] procedure Navigieren(Sender: TObject); async;
    procedure WebTreeView1Change(Sender: TObject; Node: TTreeNode);
    procedure aTreeViewNodeClick(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode);

    procedure btnDelAnhClick(Sender: TObject);

  private
    iID_AbfKon : Integer;
    aNodeZug : TTMSFNCTreeViewNode;
    aNodeAnh : TTMSFNCTreeViewNode;

    Function  Get_Punkte_Txt( aStartNode : TTMSFNCTreeViewNode; aSL : TStringList ) : String;
    Function  Get_Punkte_NOK( aStartNode : TTMSFNCTreeViewNode ) : Integer;
    Function  Get_TopNode( aStartNode : TTMSFNCTreeViewNode ) : TTMSFNCTreeViewNode;
    procedure Setze_Icons( aStartNode : TTMSFNCTreeViewNode );
    procedure Setze_IconsOK( aStartNode : TTMSFNCTreeViewNode );
    procedure Form_Anpassen;
    procedure Set_Zusammenfassung;
    Function  Get_NodyBy_ID( aID_Grp1, aID_Grp2 : Integer ): TTMSFNCTreeViewNode;


  public

  protected procedure LoadDFMValues; override; end;

var frmAbfKontrolleEdit: TfrmAbfKontrolleEdit;

const c_MaxAnzBilder = 20;

implementation

{$R *.dfm}

uses UnitMain, Konstanten, SpediFucsDatenmodul , GlobalWeb , GetStammdaten, AbfKontrollePkt;

//====================================================================================================================//

function DoAbfKontrolleEdit( var aID_AbfKon : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;
  frmMainForm.mnDispo.Enabled := False;

  frmAbfKontrolleEdit := TfrmAbfKontrolleEdit.Create(application);
  frmAbfKontrolleEdit.Popup   := True;
  frmAbfKontrolleEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmAbfKontrolleEdit.iID_AbfKon  := aID_AbfKon;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmAbfKontrolleEdit, frmAbfKontrolleEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmAbfKontrolleEdit.Resize;

  Try
    await( TModalResult, frmAbfKontrolleEdit.Execute);  // excute form and wait for close

    Result := frmAbfKontrolleEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        await( frmAbfKontrolleEdit.Daten_Speichern );
        aID_AbfKon := frmAbfKontrolleEdit.iID_AbfKon;
      End;
//
  Finally
    frmAbfKontrolleEdit.Free;
  End;


  frmMainForm.mnDispo.Enabled := True;
  frmMainForm.mMainMenu.Enabled := True;


end;


//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.Navigieren(Sender: TObject);
var aMR : TModalResult;
begin
  inherited;


  If Sender = btnNext then
    Begin
      If  pnlFahrzeug.Visible then
        Begin
          If edtZug.Tag=0 then
            Begin
             aMR := await(TModalResult, MessageDlgAsync('Bitte zuerst ein Fahrzeug wählen...', mtInformation, [mbOK]));
             Exit;
            End;


          pnlFahrzeug.Visible := False;
          aTreeView.Visible   := True ;
          aTreeView.Paint;
        End

      Else If aTreeView.Visible = True then
        Begin
          aTreeView.Visible := False ;
          pnlZusammenfassung.Visible := True;
          Set_Zusammenfassung;
        End;
    End;

  If Sender = btnPrev then
    Begin
      If  pnlZusammenfassung.Visible then
        Begin
          pnlZusammenfassung.Visible := False;
          aTreeView.Visible   := True ;
          aTreeView.Paint;
        End
      Else If aTreeView.Visible = True then
        Begin
          aTreeView.Visible := False ;
          pnlFahrzeug.Visible := True;
        End;

    End;

  btnNext.Enabled := ( pnlZusammenfassung.Visible=False);
  btnPrev.Enabled := ( pnlFahrzeug.Visible=False);

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.Set_Zusammenfassung;
var iAnzNOK : Integer;
begin

  lbMaengel.Caption := '';

  iAnzNOK :=  Get_Punkte_NOK( self.aNodeZug ) +  Get_Punkte_NOK( self.aNodeAnh );

  If iAnzNOK = 0 then
       lbMaengel.Caption := 'Es wurden keine Mängel beschrieben.'
  Else lbMaengel.Caption := 'Es wurden '+IntToStr(iAnzNOK)+' Mängel beschrieben.';

  aUnterschrift.Text := 'Unterschrift: '+ lbMitarbeiter.Caption;
  aUnterschrift.Paint;

  btnSpeichern.Enabled := ( edtZug.Tag > 0  );

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.btnGetAnhClick(Sender: TObject);
var aModalResult : TModalResult;
    iTab, iID_Fzg : Integer;
    sBez : String;
begin
  inherited;

  iTab := c_Fzg;
  iID_Fzg := 0;
  sBez := '';

  aModalResult := await( TModalResult, Get_Fahrzeug( iID_Fzg, sBez, 2 ) );
  If aModalResult <> mrOK then Exit;

  edtAnh.Text := sBez;
  edtAnh.Tag  := iID_Fzg;
  self.aNodeAnh.Text[0] := 'Anhänger '+ sBez;

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.btnGetZugmClick(Sender: TObject);
var aModalResult : TModalResult;
    iTab, iID_Fzg : Integer;
    sBez : String;
begin
  inherited;

  iTab := c_Fzg;
  iID_Fzg := frmMainForm.iID_AktFzg;
  sBez := '';

  aModalResult := await( TModalResult, Get_Fahrzeug( iID_Fzg, sBez, 1 ) );
  If aModalResult <> mrOK then Exit;

  edtZug.Text := sBez;
  edtZug.Tag  := iID_Fzg;

  self.aNodeZug.Text[0] := 'Motorwagen '+ sBez;

//  Console.log( self.aNodeZug.Text[0] );

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.Daten_Laden;
var aAbfKon : TObjAbfKon;
    aColumn: TTMSFNCTreeViewColumn;
    aNode, aSubNode : TTMSFNCTreeViewNode;
    sSQL, sDaten, sFelder : String;
    i, iAnz : Integer;
    aSL_Daten, aSL : TStringList;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
begin

  If not WaitMessage.Showing then WaitMessage.Show;


  lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;


  sSQL := '01:SELECT * FROM  ABFKON_GRP1 '  +';'
         +'02:SELECT * FROM  ABFKON_GRP2 '  +';'
         +'03:SELECT * FROM  ABFKON_PKT  '  +';'
        ;
  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,0,0 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;


  aTreeView.BeginUpdate;
  aTreeView.ClearNodeList;
  aTreeView.BitmapContainer := BitmapCont;
  aTreeView.ClearColumns;
  aTreeView.ClearNodes;
  aTreeView.ColumnsAppearance.Stretch := True;
  aTreeView.ColumnsAppearance.StretchAll := False;
  aTreeView.ColumnsAppearance.StretchColumn := 1;
  aTreeView.ColumnsAppearance.TopFont.Color    := clWhite;
  aTreeView.ColumnsAppearance.BottomFont.Color := clWhite;

  aColumn := aTreeView.Columns.Add;
  aColumn.Text := 'Prüfpunkte (2/3)';
  aColumn.Width := 300;
  aColumn.HorizontalTextAlign := gtaLeading;
//  aColumn.Fill.Color := clYellow;
//  aColumn.Fill.Kind := gfkSolid;

  aColumn := aTreeView.Columns.Add;
  aColumn.Text := 'OK/NOK';
  aColumn.HorizontalTextAlign := gtaLeading;
  aColumn.Width := 100;

  aNodeZug := aTreeView.AddNode;
  aNodeZug.Text[0] := 'Motorwagen';
  aNodeZug.Extended := True;

  aNodeAnh := aTreeView.AddNode;
  aNodeAnh.Text[0] := 'Anhänger';
  aNodeAnh.Extended := True;


  //---- ABFKON_GRP1 ----------------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];

          aAbfKon := TObjAbfKon.Create;
          aAbfKon.KENNUNG := 1;
          aAbfKon.ID_GRP1 := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_GRP1' ));
          aAbfKon.BEZEICHNUNG := GetFeldWert( sFelder, sDaten, 'BEZEICHNUNG');
          aAbfKon.FzgKennung  := SToI(GetFeldWert( sFelder, sDaten, 'FZGKENNUNG' ));

          If aAbfKon.FzgKennung=1 then aNode := aTreeView.AddNode( aNodeZug );
          If aAbfKon.FzgKennung=2 then aNode := aTreeView.AddNode( aNodeAnh );

          aNode.Extended := False;
          aNode.Text[0] := aAbfKon.BEZEICHNUNG;
          aNode.DataObject  := aAbfKon;
          aNode.DataInteger := aAbfKon.ID_GRP1;
          aNode.CollapsedIconNames[1, False] := 'OK';
          aNode.ExpandedIconNames[ 1, False] := 'OK';
        End;
    End;



  //---- ABFKON_GRP2 ----------------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '02');

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];

          aAbfKon := TObjAbfKon.Create;
          aAbfKon.KENNUNG := 2;
          aAbfKon.ID_GRP2 := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_GRP2' ));
          aAbfKon.ID_GRP1 := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_GRP1' ));
          aAbfKon.BEZEICHNUNG := GetFeldWert( sFelder, sDaten, 'BEZEICHNUNG');

          aNode := Get_NodyBy_ID( aAbfKon.ID_GRP1, 0 );

          If aNode <> nil then
            Begin
              aSubNode := aTreeView.AddNode( aNode );
              aSubNode.Extended := False;
              aSubNode.Text[0] := aAbfKon.BEZEICHNUNG;
              aSubNode.DataObject := aAbfKon;
              aSubNode.DataInteger := aAbfKon.ID_GRP2;
              aSubNode.CollapsedIconNames[1, False] := 'OK';
              aSubNode.ExpandedIconNames[ 1, False] := 'OK';
            End
          else console.log('nix gefunden: '+aAbfKon.BEZEICHNUNG);
        End;
    End;


  //---- ABFKON_PKT ----------------------------------------------------------------------
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '03');

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];

          aAbfKon := TObjAbfKon.Create;
          aAbfKon.KENNUNG := 3;
          aAbfKon.ID_PKT  := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_PKT' ));
          aAbfKon.ID_GRP2 := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_GRP2' ));
          aAbfKon.ID_GRP1 := SToI(GetFeldWert( sFelder, sDaten, 'ID_ABFKON_GRP1' ));
          aAbfKon.BEZEICHNUNG := GetFeldWert( sFelder, sDaten, 'BEZEICHNUNG');

          aNode := Get_NodyBy_ID( aAbfKon.ID_GRP1,  aAbfKon.ID_GRP2 );

          If aNode <> nil then
            Begin
              aSubNode := aTreeView.AddNode( aNode );
              aSubNode.Extended := False;
              aSubNode.Text[0] := aAbfKon.BEZEICHNUNG;
              aSubNode.Text[1] := '';
              aSubNode.DataObject  := aAbfKon;
              aSubNode.DataInteger := aAbfKon.ID_PKT;
              aSubNode.CollapsedIconNames[1, False] := 'OK_GRUEN';
              aSubNode.ExpandedIconNames[ 1, False] := 'OK_GRUEN';
            End
           Else console.log('nix: '+aAbfKon.BEZEICHNUNG+' '+Inttostr(aAbfKon.ID_GRP1) +'  '+Inttostr(aAbfKon.ID_GRP2));

        End;
    End;



  aTreeView.EndUpdate;

  aSL.Free;
  aSL_Daten.Free;


  If not bUebersetzt then Form_Uebersetzen;




  pnlFahrzeug.Align := alClient;
  aTreeView.Align   := alClient;
  pnlZusammenfassung.Align := alClient;

  pnlFahrzeug.Visible := True;

  WaitMessage.Hide;


end;

//====================================================================================================================//

function TfrmAbfKontrolleEdit.Get_NodyBy_ID( aID_Grp1, aID_Grp2 : Integer ): TTMSFNCTreeViewNode;
var i, s : Integer;
    aNode, sSubNode : TTMSFNCTreeViewNode;
    aObj  : TObjAbfKon;
    sTmp : String;
begin

  Result := nil;

  If aID_Grp1 > 0 then
    Begin
        For i := 0 to aNodeZug.Nodes.Count -1 Do
          Begin
            aNode := aNodeZug.Nodes[i];
            aObj  :=  TObjAbfKon( aNode.DataObject );
            If (aObj.ID_GRP1 = aID_Grp1) and (aObj.KENNUNG=1) then
              Begin
                Result := aNode;
                Exit;
              End;
          End;
        For i := 0 to aNodeAnh.Nodes.Count -1 Do
          Begin
            aNode := aNodeAnh.Nodes[i];
            aObj  :=  TObjAbfKon( aNode.DataObject );
            If (aObj.ID_GRP1 = aID_Grp1) and (aObj.KENNUNG=1) then
              Begin
                Result := aNode;
                Exit;
              End;
          End;

    End;

  If aID_Grp2 > 0 then
    Begin
        For i := 0 to aNodeZug.Nodes.Count -1 Do
          Begin
            aNode := aNodeZug.Nodes[i];
            aObj := TObjAbfKon(aNode.DataObject);
            If (aObj.ID_GRP2 = aID_Grp2) and (aObj.KENNUNG=2) then
              Begin
                Result := aNode;
                Exit;
              End;
            // SubNodes durchsuchen
            If aNode.Nodes.Count > 0 then
            For s := 0 to aNode.Nodes.Count -1 Do
              Begin
                sSubNode := aNode.Nodes[s];
                aObj := TObjAbfKon(sSubNode.DataObject);
                If (aObj.ID_GRP2 = aID_Grp2) and (aObj.KENNUNG=2) then
                  Begin
                    Result := sSubNode;
                    Exit;
                  End;
              End;
          End;

        For i := 0 to aNodeAnh.Nodes.Count -1 Do
          Begin
            aNode := aNodeAnh.Nodes[i];
            aObj := TObjAbfKon(aNode.DataObject);
            If (aObj.ID_GRP2 = aID_Grp2) and (aObj.KENNUNG=2) then
              Begin
                Result := aNode;
                Exit;
              End;
            // SubNodes durchsuchen
            If aNode.Nodes.Count > 0 then
            For s := 0 to aNode.Nodes.Count -1 Do
              Begin
                sSubNode := aNode.Nodes[s];
                aObj := TObjAbfKon(sSubNode.DataObject);
                If (aObj.ID_GRP2 = aID_Grp2) and (aObj.KENNUNG=2) then
                  Begin
                    Result := sSubNode;
                    Exit;
                  End;
              End;
          End;
    End;

end;

//====================================================================================================================//

function TfrmAbfKontrolleEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL, sBezeich, sTmp, sBase64 : String;
    aObj : TParam;
    iErg : Integer;
    aSL : TStringList;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  If self.iID_AbfKon=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr,0);
      aObj.Datum1 := Now;
      aObj.String1 := frmMainForm.User_Account;
      aObj.Integer1 := edtZug.Tag;
      aObj.Integer2 := edtAnh.Tag;
      aObj.Integer3 := BToI(optFahrbereit.Checked);
      aObj.Integer4 := StrToIntDef( edtKmStand.Text,0);

       ClientConn := TXDataWebClient.Create(nil);
       ClientConn.Connection := frmMainForm.XDataConn;

       Response := await( ClientConn.RawInvokeAsync('ISystemService.AbfKontrolleIns', [ aObj] ));

       iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

       self.iID_AbfKon := iErg;

      ClientConn.Free;
    End;




   // Punkte einsammeln......
   //
   aSL := TStringList.Create;
   sTmp := Get_Punkte_Txt( self.aNodeZug, aSL ) + Get_Punkte_Txt( self.aNodeAnh, aSL ) ;

console.log(sTmp);

   // die Unterschrift auch noch dazu nehmen
   sBase64 := StringReplace( aUnterschrift.GetBase64Img, c_ImgVorsatz, '', [rfReplaceAll] );
   aSL.Add( 'SIG;'+ aUnterschrift.Text +';' + sBase64 +';' );

   For iErg := 0 to aSL.Count-1 Do  Console.Log( Copy(aSL[iErg], 1, 50) );


  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  Response := await( ClientConn.RawInvokeAsync('ISystemService.AbfKontrollePkt', [iID_AbfKon, aSL.Text] ));

  iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

  self.iID_AbfKon := iErg;

  ClientConn.Free;

  aSL.Free;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.WebFormShow(Sender: TObject);
begin

//  WaitMessage.Show;
//
  Sprach_Daten_Laden('MABSTEDIT', frmMainForm.iID_Sprache );
//
  Daten_Laden;

  Form_Anpassen;

  Inherited;


end;

procedure TfrmAbfKontrolleEdit.WebTreeView1Change(Sender: TObject; Node: TTreeNode);
begin
  inherited;

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.aTreeViewNodeClick(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode);
begin
  inherited;
  If ANode.Node.Expanded then
       aTreeView.CollapseNode(ANode.Node)
  Else aTreeView.ExpandNode(ANode.Node)
end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.NodeEdit(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode;  AColumn: Integer);
var aObj : TObjAbfKon;
    aParentNode, aTopNode : TTMSFNCTreeViewNode;
    aMr : TModalResult;
    sTmp : String;
begin
  inherited;

  If aColumn <> 1 then Exit;

  aObj :=  TObjAbfKon( aNode.Node.DataObject );

  If aObj = nil then Exit;

  aParentNode :=  aNode.Node.GetParent;

  If aParentNode <> nil then aObj.BezeichParent := aParentNode.Text[0];

  If aObj.KENNUNG <> 3 then Exit;

  aTopNode := Get_TopNode( aNode.Node );

  If aTopNode = aNodeAnh then
    If edtAnh.Tag=0 then
      Begin
        aMr := await(TModalResult, MessageDlgAsync('Bitte zuerst einen Anhäger wählen...', mtInformation, [mbOK]));
        Navigieren(btnPrev);
        Exit;
      End;

  // Edit-Dialog aufrufen
  //
  await(  DoAbfKontrollePkt( aObj ) );


  sTmp := '';

  If aObj.FehlerText <> '' then sTmp := 'T';
  If aObj.FehlerBilder > 0 then sTmp := sTmp + ' B';

  sTmp := Trim(sTmp);

  If aObj.NOK = False then
    Begin
      aNode.Node.CollapsedIconNames[1, False] := 'OK_GRUEN';
      aNode.Node.ExpandedIconNames[ 1, False] := 'OK_GRUEN';
    End
  Else
    Begin
      aNode.Node.CollapsedIconNames[1, False] := 'NOK';
      aNode.Node.ExpandedIconNames[ 1, False] := 'NOK';
    End;


  aNode.Node.Text[1] := sTmp;


  Setze_Icons( self.aNodeZug ); ;
  Setze_Icons( self.aNodeAnh ); ;

end;


//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.Setze_Icons( aStartNode : TTMSFNCTreeViewNode );
var aNode, aSubNode : TTMSFNCTreeViewNode;
    aObj  : TObjAbfKon;
    i : Integer;
    sIcon : String;
begin

//console.log('Start: Setze_Icons '+aStartNode.Text[0] );

  Setze_IconsOK( aStartNode );

  If TObjAbfKon( aStartNode.DataObject ) <> nil then
    Begin
      aObj := TObjAbfKon( aStartNode.DataObject );
      If aObj.KENNUNG = 3 then // PKT
        Begin
         sIcon := aStartNode.CollapsedIconNames[1, False];
         If sIcon = 'NOK' then
           Begin
             aNode := aStartNode.GetParent;
               If aNode <> nil then
                 Begin
                   aNode.CollapsedIconNames[1, False] := 'NOK';
                   aNode.ExpandedIconNames[ 1, False] := 'NOK';
                   aSubNode := aNode.GetParent;
                   If aSubNode <> nil then
                      Begin
                        aSubNode.CollapsedIconNames[1, False] := 'NOK';
                        aSubNode.ExpandedIconNames[ 1, False] := 'NOK';
                      End;
                 End;
           End;

        End;
    End;

  If aStartNode.Nodes.Count > 0 then
    For i := 0 to aStartNode.Nodes.Count -1 Do
      Begin
        aNode := aStartNode.Nodes[i];
        Setze_Icons( aNode );
      End;

//console.log('Ende: Setze_Icons-------------------')

end;

//====================================================================================================================//
// nur GRP1 und GRP2

procedure TfrmAbfKontrolleEdit.Setze_IconsOK( aStartNode : TTMSFNCTreeViewNode );
var  aNode, sSubNode : TTMSFNCTreeViewNode;
    aObj  : TObjAbfKon;
    i : Integer;
begin

  If TObjAbfKon( aStartNode.DataObject ) <> nil then
    Begin
      aObj := TObjAbfKon( aStartNode.DataObject );
      If aObj.KENNUNG < 3 then // PKT
        Begin
          aStartNode.CollapsedIconNames[1, False] := 'OK';
          aStartNode.ExpandedIconNames[ 1, False] := 'OK';
        End;
    End;

  If aStartNode.Nodes.Count > 0 then
    For i := 0 to aStartNode.Nodes.Count -1 Do
      Begin
        aNode := aStartNode.Nodes[i];
        Setze_IconsOK( aNode );
      End;

end;

//====================================================================================================================//
// oberstes Node ermitteln

Function  TfrmAbfKontrolleEdit.Get_TopNode( aStartNode : TTMSFNCTreeViewNode ) : TTMSFNCTreeViewNode;
var aNode : TTMSFNCTreeViewNode;
begin

  Result := aStartNode;

  aNode := aStartNode.GetParent;
  If aNode <> nil then
    Begin
      Result := aNode;
      If aNode.GetParent <> nil then Result := aNode.GetParent;
    End;

end;

//====================================================================================================================//

Function TfrmAbfKontrolleEdit.Get_Punkte_Txt( aStartNode : TTMSFNCTreeViewNode; aSL : TStringList ) : String;
var aNode, sSubNode : TTMSFNCTreeViewNode;
    aObj  : TObjAbfKon;
    i : Integer;
    sTmp : String;
begin

  Result := '';

  If TObjAbfKon( aStartNode.DataObject ) <> nil then
    Begin
      aObj := TObjAbfKon( aStartNode.DataObject );
      If (aObj.KENNUNG=3) then
      If aObj.NOK = True then
        Begin
          sTmp := 'PKT;'+ IntToStr( aObj.ID_GRP1 )+';' +IntToStr( aObj.ID_GRP2 )+';' +IntToStr( aObj.ID_PKT )+';'
                    +aObj.BEZEICHNUNG+';' + ReplaceStr( aObj.FehlerText, chr(10), '##' )+';';
          aSl.Add(sTmp);

          For i := 1 to c_MaxAnzBilder Do
           If aObj.BilderDaten[i] <>'' then
             Begin
               sTmp :=  'PIC;'+ IntToStr( aObj.ID_GRP1 )+';' +IntToStr( aObj.ID_GRP2 )+';' +IntToStr( aObj.ID_PKT )+';'
                        +aObj.BilderName[i] +';' + aObj.BilderDaten[i] +';' ;
               aSL.Add(sTmp);

             End;
        End;
    End;

  If aStartNode.Nodes.Count > 0 then
    For i := 0 to aStartNode.Nodes.Count -1 Do
      Begin
        aNode := aStartNode.Nodes[i];
        Get_Punkte_Txt( aNode, aSL );
      End;

end;

//====================================================================================================================//

Function TfrmAbfKontrolleEdit.Get_Punkte_NOK( aStartNode : TTMSFNCTreeViewNode ) : Integer;
var aNode, sSubNode : TTMSFNCTreeViewNode;
    aObj  : TObjAbfKon;
    i : Integer;
begin

  Result := 0;

  If TObjAbfKon( aStartNode.DataObject ) <> nil then
    Begin
      aObj := TObjAbfKon( aStartNode.DataObject );
      If aObj.KENNUNG = 3 then
          If aStartNode.CollapsedIconNames[1, False] = 'NOK' then Inc(Result);
    End;

  If aStartNode.Nodes.Count > 0 then
    For i := 0 to aStartNode.Nodes.Count -1 Do
      Begin
        aNode := aStartNode.Nodes[i];
        Result := Result + Get_Punkte_NOK( aNode );
      End;

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.btnSpeichernClick(Sender: TObject);
var sTmp : String;
    aMR : TModalResult;
    iAnzNOK : Integer;
begin
  inherited;

  If Sender = btnSpeichern then
    Begin
      If aUnterschrift.Empty then
        Begin
          aMR := await(TModalResult, MessageDlgAsync('Bitte zuerst unterschreiben...', mtInformation, [mbOK]));
          Exit;
        End;
      ModalResult := mrOK;
      Close;
     End;

  If Sender = btnAbbrechen then
    Begin
      iAnzNOK := Get_Punkte_NOK( self.aNodeZug ) +  Get_Punkte_NOK( self.aNodeAnh );

      If iAnzNOK > 0 then
        Begin
          aMR := await(TModalResult, MessageDlgAsync('Vorgang abbrechen ?', mtConfirmation, [mbYes, mbNo]));
          If aMR <> mrYes then Exit;
        End;

      ModalResult := mrCancel;
      Close;
    End;



end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.btnDelAnhClick(Sender: TObject);
begin
  inherited;

  edtAnh.Text := '';
  edtAnh.Tag  := 0;
  self.aNodeAnh.Text[0] := 'Anhänger';

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;

  // Komponenten
  iZielBreite := Trunc( self.Width * 0.95 );
  If iZielBreite > 500 then iZielBreite := 500;

  lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

end;

//====================================================================================================================//

procedure TfrmAbfKontrolleEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbAbfKonCaption := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  btnNext := TTMSFNCToolBarButton.Create(Self);
  btnPrev := TTMSFNCToolBarButton.Create(Self);
  pnlZusammenfassung := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  lbMaengel := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  btnSpeichern := TTMSFNCToolBarButton.Create(Self);
  aUnterschrift := TTMSFNCSignatureCapture.Create(Self);
  optFahrbereit := TRadioButton.Create(Self);
  optNichtFahrbereit := TRadioButton.Create(Self);
  aTreeView := TTMSFNCTreeView.Create(Self);
  aBitmapContainerTreeView := TTMSFNCBitmapContainer.Create(Self);
  pnlFahrzeug := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  edtZug := TEdit.Create(Self);
  edtAnh := TEdit.Create(Self);
  edtKmStand := TEdit.Create(Self);
  btnGetZugm := TTMSFNCToolBarButton.Create(Self);
  btnGetAnh := TTMSFNCToolBarButton.Create(Self);
  edtDatum := TDateTimePicker.Create(Self);
  btnDelAnh := TTMSFNCToolBarButton.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbAbfKonCaption.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnPrev.BeforeLoadDFMValues;
  pnlZusammenfassung.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  lbMaengel.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  aUnterschrift.BeforeLoadDFMValues;
  optFahrbereit.BeforeLoadDFMValues;
  optNichtFahrbereit.BeforeLoadDFMValues;
  aTreeView.BeforeLoadDFMValues;
  aBitmapContainerTreeView.BeforeLoadDFMValues;
  pnlFahrzeug.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  edtZug.BeforeLoadDFMValues;
  edtAnh.BeforeLoadDFMValues;
  edtKmStand.BeforeLoadDFMValues;
  btnGetZugm.BeforeLoadDFMValues;
  btnGetAnh.BeforeLoadDFMValues;
  edtDatum.BeforeLoadDFMValues;
  btnDelAnh.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 503;
    Height := 503;
    Caption := 'frmAbfKontrolleEdit';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.Left := 227;
    WaitMessage.Top := 282;
    BitmapCont.Left := 42;
    BitmapCont.Top := 133;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 503;
    WebPanel1.Height := 84;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 2;
    lbAbfKonCaption.SetParentComponent(WebPanel1);
    lbAbfKonCaption.Name := 'lbAbfKonCaption';
    lbAbfKonCaption.Left := 10;
    lbAbfKonCaption.Top := 56;
    lbAbfKonCaption.Width := 143;
    lbAbfKonCaption.Height := 18;
    lbAbfKonCaption.Caption := 'Abfahrtskontrolle';
    lbAbfKonCaption.Font.Charset := DEFAULT_CHARSET;
    lbAbfKonCaption.Font.Color := clBlack;
    lbAbfKonCaption.Font.Height := -15;
    lbAbfKonCaption.Font.Name := 'Verdana';
    lbAbfKonCaption.Font.Style := [fsBold];
    lbAbfKonCaption.HeightPercent := 100.000000000000000000;
    lbAbfKonCaption.ParentFont := False;
    lbAbfKonCaption.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 163;
    lbMitarbeiter.Top := 56;
    lbMitarbeiter.Width := 54;
    lbMitarbeiter.Height := 18;
    lbMitarbeiter.Caption := 'Fahrer';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -15;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 70;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 0;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnSpeichernClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    btnNext.SetParentComponent(WebPanel1);
    btnNext.Name := 'btnNext';
    btnNext.Left := 179;
    btnNext.Top := 6;
    btnNext.Width := 91;
    btnNext.Height := 44;
    btnNext.Cursor := crHandPoint;
    btnNext.ParentDoubleBuffered := False;
    btnNext.DoubleBuffered := True;
    btnNext.Font.Charset := ANSI_CHARSET;
    btnNext.Font.Color := clWindowText;
    btnNext.Font.Height := -13;
    btnNext.Font.Name := 'Verdana';
    btnNext.Font.Style := [];
    btnNext.ParentColor := True;
    btnNext.TabOrder := 1;
    SetEvent(btnNext, Self, 'OnClick', 'Navigieren');
    btnNext.Text := '';
    btnNext.TextVisible := False;
    btnNext.Bitmaps.Clear;
    with btnNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNext.BitmapVisible := True;
    btnNext.BitmapContainer := BitmapCont;
    btnNext.ControlIndex := 0;
    btnPrev.SetParentComponent(WebPanel1);
    btnPrev.Name := 'btnPrev';
    btnPrev.Left := 84;
    btnPrev.Top := 6;
    btnPrev.Width := 91;
    btnPrev.Height := 44;
    btnPrev.Cursor := crHandPoint;
    btnPrev.ParentDoubleBuffered := False;
    btnPrev.DoubleBuffered := True;
    btnPrev.Font.Charset := ANSI_CHARSET;
    btnPrev.Font.Color := clWindowText;
    btnPrev.Font.Height := -13;
    btnPrev.Font.Name := 'Verdana';
    btnPrev.Font.Style := [];
    btnPrev.ParentColor := True;
    btnPrev.TabOrder := 2;
    SetEvent(btnPrev, Self, 'OnClick', 'Navigieren');
    btnPrev.Text := '';
    btnPrev.TextVisible := False;
    btnPrev.Bitmaps.Clear;
    with btnPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnPrev.BitmapVisible := True;
    btnPrev.BitmapContainer := BitmapCont;
    btnPrev.ControlIndex := 0;
    pnlZusammenfassung.SetParentComponent(Self);
    pnlZusammenfassung.Name := 'pnlZusammenfassung';
    pnlZusammenfassung.Left := 74;
    pnlZusammenfassung.Top := 101;
    pnlZusammenfassung.Width := 487;
    pnlZusammenfassung.Height := 375;
    pnlZusammenfassung.ChildOrder := 4;
    pnlZusammenfassung.Color := 16776441;
    pnlZusammenfassung.TabOrder := 4;
    pnlZusammenfassung.Visible := False;
    WebLabel6.SetParentComponent(pnlZusammenfassung);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 0;
    WebLabel6.Width := 487;
    WebLabel6.Height := 22;
    WebLabel6.Align := alTop;
    WebLabel6.AutoSize := False;
    WebLabel6.Caption := ' Zusammenfassung (3/3)';
    WebLabel6.Color := 12021811;
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWhite;
    WebLabel6.Font.Height := -16;
    WebLabel6.Font.Name := 'Verdana';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.Transparent := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(pnlZusammenfassung);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 27;
    WebLabel7.Width := 468;
    WebLabel7.Height := 16;
    WebLabel7.Margins.Left := 5;
    WebLabel7.Margins.Right := 5;
    WebLabel7.Caption := 'Die Abfahrtskontrolle nach bestem Wissen und Gewissen durchgef'#252'hrt.';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WordWrap := True;
    WebLabel7.WidthPercent := 100.000000000000000000;
    lbMaengel.SetParentComponent(pnlZusammenfassung);
    lbMaengel.Name := 'lbMaengel';
    lbMaengel.Left := 8;
    lbMaengel.Top := 61;
    lbMaengel.Width := 298;
    lbMaengel.Height := 16;
    lbMaengel.Caption := 'Alle gefundenen M'#228'ngel wurden beschrieben.';
    lbMaengel.HeightPercent := 100.000000000000000000;
    lbMaengel.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(pnlZusammenfassung);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 8;
    WebLabel9.Top := 107;
    WebLabel9.Width := 114;
    WebLabel9.Height := 16;
    WebLabel9.Caption := 'Das Fahrzeug ist ';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    btnSpeichern.SetParentComponent(pnlZusammenfassung);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 12;
    btnSpeichern.Top := 319;
    btnSpeichern.Width := 181;
    btnSpeichern.Height := 44;
    btnSpeichern.Cursor := crHandPoint;
    btnSpeichern.ParentDoubleBuffered := False;
    btnSpeichern.DoubleBuffered := True;
    btnSpeichern.Enabled := False;
    btnSpeichern.Font.Charset := ANSI_CHARSET;
    btnSpeichern.Font.Color := clWindowText;
    btnSpeichern.Font.Height := -13;
    btnSpeichern.Font.Name := 'Verdana';
    btnSpeichern.Font.Style := [];
    btnSpeichern.ParentColor := True;
    btnSpeichern.TabOrder := 0;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    btnSpeichern.Text := '';
    btnSpeichern.TextVisible := False;
    btnSpeichern.Bitmaps.Clear;
    with btnSpeichern.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnSpeichern.BitmapVisible := True;
    btnSpeichern.BitmapContainer := BitmapCont;
    btnSpeichern.ControlIndex := 0;
    aUnterschrift.SetParentComponent(pnlZusammenfassung);
    aUnterschrift.Name := 'aUnterschrift';
    aUnterschrift.Left := 14;
    aUnterschrift.Top := 182;
    aUnterschrift.Width := 428;
    aUnterschrift.Height := 131;
    aUnterschrift.ParentDoubleBuffered := False;
    aUnterschrift.DoubleBuffered := True;
    aUnterschrift.Font.Charset := DEFAULT_CHARSET;
    aUnterschrift.Font.Color := clWindowText;
    aUnterschrift.Font.Height := -13;
    aUnterschrift.Font.Name := 'Verdana';
    aUnterschrift.Font.Style := [];
    aUnterschrift.TabOrder := 1;
    aUnterschrift.Pen.Color := clBlack;
    aUnterschrift.Text := 'Hier unterschreiben';
    aUnterschrift.TextPosition.Line.Color := clGray;
    aUnterschrift.ClearSig.Image.LoadFromFile('AbfKontrolleEdit.pnlZusammenfassung.aUnterschrift.ClearSig.Image.png');
    optFahrbereit.SetParentComponent(pnlZusammenfassung);
    optFahrbereit.Name := 'optFahrbereit';
    optFahrbereit.Left := 139;
    optFahrbereit.Top := 107;
    optFahrbereit.Width := 113;
    optFahrbereit.Height := 22;
    optFahrbereit.Cursor := crHandPoint;
    optFahrbereit.Caption := 'fahrbereit';
    optFahrbereit.Checked := True;
    optFahrbereit.ChildOrder := 8;
    optFahrbereit.Color := clNone;
    optFahrbereit.GroupName := 'ABC';
    optFahrbereit.HeightPercent := 100.000000000000000000;
    optFahrbereit.WidthPercent := 100.000000000000000000;
    optNichtFahrbereit.SetParentComponent(pnlZusammenfassung);
    optNichtFahrbereit.Name := 'optNichtFahrbereit';
    optNichtFahrbereit.Left := 139;
    optNichtFahrbereit.Top := 139;
    optNichtFahrbereit.Width := 152;
    optNichtFahrbereit.Height := 22;
    optNichtFahrbereit.Cursor := crHandPoint;
    optNichtFahrbereit.Caption := 'nicht fahrbereit';
    optNichtFahrbereit.Checked := False;
    optNichtFahrbereit.ChildOrder := 8;
    optNichtFahrbereit.Color := clNone;
    optNichtFahrbereit.GroupName := 'ABC';
    optNichtFahrbereit.HeightPercent := 100.000000000000000000;
    optNichtFahrbereit.WidthPercent := 100.000000000000000000;
    aTreeView.SetParentComponent(Self);
    aTreeView.Name := 'aTreeView';
    aTreeView.AlignWithMargins := True;
    aTreeView.Left := 10;
    aTreeView.Top := 99;
    aTreeView.Width := 316;
    aTreeView.Height := 297;
    aTreeView.Margins.Left := 0;
    aTreeView.Margins.Top := 0;
    aTreeView.Margins.Right := 0;
    aTreeView.Margins.Bottom := 0;
    aTreeView.ParentDoubleBuffered := False;
    aTreeView.DoubleBuffered := True;
    aTreeView.Font.Charset := DEFAULT_CHARSET;
    aTreeView.Font.Color := clWhite;
    aTreeView.Font.Height := -16;
    aTreeView.Font.Name := 'Verdana';
    aTreeView.Font.Style := [];
    aTreeView.ParentFont := False;
    aTreeView.ParentShowHint := False;
    aTreeView.ShowHint := True;
    aTreeView.TabOrder := 5;
    aTreeView.Visible := False;
    aTreeView.Stroke.Color := clDarkcyan;
    aTreeView.BitmapContainer := BitmapCont;
    aTreeView.HorizontalScrollBarVisible := False;
    aTreeView.GroupsAppearance.TopSize := 50.000000000000000000;
    aTreeView.GroupsAppearance.BottomSize := 50.000000000000000000;
    aTreeView.GroupsAppearance.TopFill.Kind := gfkNone;
    aTreeView.GroupsAppearance.BottomFill.Kind := gfkNone;
    aTreeView.GroupsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    aTreeView.GroupsAppearance.TopFont.Color := clBlack;
    aTreeView.GroupsAppearance.TopFont.Height := -16;
    aTreeView.GroupsAppearance.TopFont.Name := 'Verdana';
    aTreeView.GroupsAppearance.TopFont.Style := [];
    aTreeView.GroupsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    aTreeView.GroupsAppearance.BottomFont.Color := clBlack;
    aTreeView.GroupsAppearance.BottomFont.Height := -16;
    aTreeView.GroupsAppearance.BottomFont.Name := 'Verdana';
    aTreeView.GroupsAppearance.BottomFont.Style := [];
    aTreeView.Columns.Clear;
    with aTreeView.Columns.Add do
    begin
      Name := 'Column0';
      Text := 'Model';
      Width := 100.000000000000000000;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Tahoma';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -11;
      TopFont.Name := 'Tahoma';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -11;
      BottomFont.Name := 'Tahoma';
      BottomFont.Style := [];
    end;
    with aTreeView.Columns.Add do
    begin
      Name := 'Column1';
      Text := 'Year';
      Width := 100.000000000000000000;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Tahoma';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -11;
      TopFont.Name := 'Tahoma';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -11;
      BottomFont.Name := 'Tahoma';
      BottomFont.Style := [];
    end;
    with aTreeView.Columns.Add do
    begin
      Name := 'Column2';
      Text := 'Miles';
      Width := 100.000000000000000000;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Tahoma';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -11;
      TopFont.Name := 'Tahoma';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -11;
      BottomFont.Name := 'Tahoma';
      BottomFont.Style := [];
    end;
    aTreeView.Nodes.Clear;
    with aTreeView.Nodes.Add do
    begin
      Values.Clear;
      with Values.Add do
      begin
        Text := 'Managers';
      end;
      Expanded := True;
      Tag := 0;
      Nodes.Clear;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Liam Andersson';
        end;
        with Values.Add do
        begin
          Text := 'Research';
        end;
        with Values.Add do
        begin
          Text := 'Office';
        end;
        Tag := 0;
      end;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Arthur Peeters';
        end;
        with Values.Add do
        begin
          Text := 'Finance';
        end;
        with Values.Add do
        begin
          Text := 'Abroad';
        end;
        Tag := 0;
      end;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Isabella Ali';
        end;
        with Values.Add do
        begin
          Text := 'Customers';
        end;
        with Values.Add do
        begin
          Text := 'Flight';
        end;
        Tag := 0;
      end;
    end;
    with aTreeView.Nodes.Add do
    begin
      Values.Clear;
      with Values.Add do
      begin
        Text := 'Specialists';
      end;
      Expanded := True;
      Tag := 0;
      Nodes.Clear;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Liam Ali';
        end;
        with Values.Add do
        begin
          Text := 'Finance';
        end;
        with Values.Add do
        begin
          Text := 'Office';
        end;
        Tag := 0;
      end;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Arthur Andersson';
        end;
        with Values.Add do
        begin
          Text := 'Customers';
        end;
        with Values.Add do
        begin
          Text := 'Office';
        end;
        Tag := 0;
      end;
    end;
    with aTreeView.Nodes.Add do
    begin
      Values.Clear;
      with Values.Add do
      begin
        Text := 'Assistants';
      end;
      Tag := 0;
      Nodes.Clear;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Liam Smith';
        end;
        with Values.Add do
        begin
          Text := 'Customers';
        end;
        with Values.Add do
        begin
          Text := 'Abroad';
        end;
        Tag := 0;
      end;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Marie Peeters';
        end;
        with Values.Add do
        begin
          Text := 'HR';
        end;
        with Values.Add do
        begin
          Text := 'Flight';
        end;
        Tag := 0;
      end;
      with Nodes.Add do
      begin
        Values.Clear;
        with Values.Add do
        begin
          Text := 'Yusuf Andersson';
        end;
        with Values.Add do
        begin
          Text := 'Marketing';
        end;
        with Values.Add do
        begin
          Text := 'Office';
        end;
        Tag := 0;
      end;
    end;
    aTreeView.ColumnsAppearance.Stretch := False;
    aTreeView.ColumnsAppearance.StretchColumn := 0;
    aTreeView.ColumnsAppearance.StretchAll := False;
    aTreeView.ColumnsAppearance.TopSize := 25.000000000000000000;
    aTreeView.ColumnsAppearance.BottomSize := 25.000000000000000000;
    aTreeView.ColumnsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    aTreeView.ColumnsAppearance.TopFont.Color := clBlack;
    aTreeView.ColumnsAppearance.TopFont.Height := -16;
    aTreeView.ColumnsAppearance.TopFont.Name := 'Verdana';
    aTreeView.ColumnsAppearance.TopFont.Style := [];
    aTreeView.ColumnsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    aTreeView.ColumnsAppearance.BottomFont.Color := clBlack;
    aTreeView.ColumnsAppearance.BottomFont.Height := -16;
    aTreeView.ColumnsAppearance.BottomFont.Name := 'Verdana';
    aTreeView.ColumnsAppearance.BottomFont.Style := [];
    aTreeView.ColumnsAppearance.TopFill.Color := 12021811;
    aTreeView.ColumnsAppearance.TopFill.ColorTo := clWhite;
    aTreeView.ColumnsAppearance.BottomFill.Kind := gfkNone;
    aTreeView.ColumnsAppearance.BottomFill.Color := 12021811;
    aTreeView.ColumnsAppearance.TopStroke.Kind := gskNone;
    aTreeView.NodesAppearance.ShowFocus := False;
    aTreeView.NodesAppearance.ExpandWidth := 15.000000000000000000;
    aTreeView.NodesAppearance.ExpandHeight := 30.000000000000000000;
    aTreeView.NodesAppearance.LevelIndent := 20.000000000000000000;
    aTreeView.NodesAppearance.FixedHeight := 30.000000000000000000;
    aTreeView.NodesAppearance.VariableMinimumHeight := 30.000000000000000000;
    aTreeView.NodesAppearance.Font.Charset := DEFAULT_CHARSET;
    aTreeView.NodesAppearance.Font.Color := clBlack;
    aTreeView.NodesAppearance.Font.Height := -16;
    aTreeView.NodesAppearance.Font.Name := 'Verdana';
    aTreeView.NodesAppearance.Font.Style := [];
    aTreeView.NodesAppearance.TitleFont.Charset := DEFAULT_CHARSET;
    aTreeView.NodesAppearance.TitleFont.Color := clBlack;
    aTreeView.NodesAppearance.TitleFont.Height := -16;
    aTreeView.NodesAppearance.TitleFont.Name := 'Verdana';
    aTreeView.NodesAppearance.TitleFont.Style := [];
    aTreeView.NodesAppearance.SelectedFontColor := clBlack;
    aTreeView.NodesAppearance.SelectedTitleFontColor := clBlack;
    aTreeView.NodesAppearance.SelectedFill.Color := 16762250;
    aTreeView.NodesAppearance.SelectedStroke.Color := 15702829;
    aTreeView.NodesAppearance.SelectedStroke.Width := 2.000000000000000000;
    aTreeView.NodesAppearance.ExtendedFill.Color := 9830399;
    aTreeView.NodesAppearance.ExtendedFont.Charset := DEFAULT_CHARSET;
    aTreeView.NodesAppearance.ExtendedFont.Color := clBlack;
    aTreeView.NodesAppearance.ExtendedFont.Height := -16;
    aTreeView.NodesAppearance.ExtendedFont.Name := 'Verdana';
    aTreeView.NodesAppearance.ExtendedFont.Style := [];
    aTreeView.NodesAppearance.ExpandNodeIcon.LoadFromFile('AbfKontrolleEdit.aTreeView.NodesAppearance.ExpandNodeIcon.png');
    aTreeView.NodesAppearance.CollapseNodeIcon.LoadFromFile('AbfKontrolleEdit.aTreeView.NodesAppearance.CollapseNodeIcon.png');
    aTreeView.NodesAppearance.ExpandNodeIconLarge.LoadFromFile('AbfKontrolleEdit.aTreeView.NodesAppearance.ExpandNodeIconLarge.png');
    aTreeView.NodesAppearance.CollapseNodeIconLarge.LoadFromFile('AbfKontrolleEdit.aTreeView.NodesAppearance.CollapseNodeIconLarge.png');
    aTreeView.Interaction.ExtendedSelectable := True;
    aTreeView.Interaction.KeyboardEdit := False;
    aTreeView.Interaction.Lookup.AutoExpand := True;
    aTreeView.GlobalFont.Color := clBlack;
    aTreeView.GlobalFont.Size := 12.000000000000000000;
    aTreeView.GlobalFont.Name := 'Verdana';
    SetEvent(aTreeView, Self, 'OnNodeClick', 'aTreeViewNodeClick');
    SetEvent(aTreeView, Self, 'OnNodeValueClick', 'NodeEdit');
    aTreeView.DefaultViewJSONOptions.NameHTMLTemplate := '<#NAME>';
    aTreeView.DefaultViewJSONOptions.ValueHTMLTemplate := '<#VALUE>';
    aBitmapContainerTreeView.SetParentComponent(aTreeView);
    aBitmapContainerTreeView.Name := 'aBitmapContainerTreeView';
    aBitmapContainerTreeView.Left := 512;
    aBitmapContainerTreeView.Top := 256;
    aBitmapContainerTreeView.Width := 26;
    aBitmapContainerTreeView.Height := 26;
    aBitmapContainerTreeView.Visible := True;
    aBitmapContainerTreeView.Items.Clear;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap.png');
      Name := 'cake4.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_1.png');
      Name := 'pastry3.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_2.png');
      Name := 'pastry5.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_3.png');
      Name := 'balloon.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_4.png');
      Name := 'biscuit1.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_5.png');
      Name := 'cake1.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_6.png');
      Name := 'cake2.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_7.png');
      Name := 'cake3.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_8.png');
      Name := 'cake5.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_9.png');
      Name := 'cake6.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_10.png');
      Name := 'cake7.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_11.png');
      Name := 'cake8.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_12.png');
      Name := 'cake9.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_13.png');
      Name := 'deco1.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_14.png');
      Name := 'pastry1.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_15.png');
      Name := 'pastry2.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_16.png');
      Name := 'pastry4.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_17.png');
      Name := 'pastry6.png';
      Tag := 0;
    end;
    with aBitmapContainerTreeView.Items.Add do
    begin
      Bitmap.LoadFromFile('AbfKontrolleEdit.aBitmapContainerTreeView.Items.Bitmap_18.png');
      Name := 'pie1.png';
      Tag := 0;
    end;
    pnlFahrzeug.SetParentComponent(Self);
    pnlFahrzeug.Name := 'pnlFahrzeug';
    pnlFahrzeug.Left := 65;
    pnlFahrzeug.Top := 134;
    pnlFahrzeug.Width := 403;
    pnlFahrzeug.Height := 300;
    pnlFahrzeug.ChildOrder := 4;
    pnlFahrzeug.Color := 16776441;
    pnlFahrzeug.Font.Charset := ANSI_CHARSET;
    pnlFahrzeug.Font.Color := clWindowText;
    pnlFahrzeug.Font.Height := -16;
    pnlFahrzeug.Font.Name := 'Verdana';
    pnlFahrzeug.Font.Style := [];
    pnlFahrzeug.ParentFont := False;
    pnlFahrzeug.TabOrder := 3;
    pnlFahrzeug.Visible := False;
    WebLabel1.SetParentComponent(pnlFahrzeug);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 10;
    WebLabel1.Top := 87;
    WebLabel1.Width := 73;
    WebLabel1.Height := 18;
    WebLabel1.Caption := 'Fahrzeug';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(pnlFahrzeug);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 10;
    WebLabel2.Top := 171;
    WebLabel2.Width := 77;
    WebLabel2.Height := 18;
    WebLabel2.Caption := 'Anh'#228'nger';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlFahrzeug);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 10;
    WebLabel3.Top := 120;
    WebLabel3.Width := 79;
    WebLabel3.Height := 18;
    WebLabel3.Caption := 'Kilometer';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(pnlFahrzeug);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 10;
    WebLabel4.Top := 38;
    WebLabel4.Width := 54;
    WebLabel4.Height := 18;
    WebLabel4.Caption := 'Datum';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(pnlFahrzeug);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 403;
    WebLabel5.Height := 22;
    WebLabel5.Align := alTop;
    WebLabel5.AutoSize := False;
    WebLabel5.Caption := ' Fahrzeug w'#228'hlen (1/3)';
    WebLabel5.Color := 12021811;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWhite;
    WebLabel5.Font.Height := -16;
    WebLabel5.Font.Name := 'Verdana';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.Transparent := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    edtZug.SetParentComponent(pnlFahrzeug);
    edtZug.Name := 'edtZug';
    edtZug.Left := 97;
    edtZug.Top := 87;
    edtZug.Width := 172;
    edtZug.Height := 22;
    edtZug.Color := 16776441;
    edtZug.HeightPercent := 100.000000000000000000;
    edtZug.ReadOnly := True;
    edtZug.WidthPercent := 100.000000000000000000;
    edtAnh.SetParentComponent(pnlFahrzeug);
    edtAnh.Name := 'edtAnh';
    edtAnh.Left := 97;
    edtAnh.Top := 168;
    edtAnh.Width := 172;
    edtAnh.Height := 22;
    edtAnh.ChildOrder := 2;
    edtAnh.Color := 16776441;
    edtAnh.HeightPercent := 100.000000000000000000;
    edtAnh.ReadOnly := True;
    edtAnh.WidthPercent := 100.000000000000000000;
    edtKmStand.SetParentComponent(pnlFahrzeug);
    edtKmStand.Name := 'edtKmStand';
    edtKmStand.Left := 98;
    edtKmStand.Top := 120;
    edtKmStand.Width := 135;
    edtKmStand.Height := 22;
    edtKmStand.ChildOrder := 2;
    edtKmStand.EditType := weNumeric;
    edtKmStand.HeightPercent := 100.000000000000000000;
    edtKmStand.SpellCheck := False;
    edtKmStand.WidthPercent := 100.000000000000000000;
    btnGetZugm.SetParentComponent(pnlFahrzeug);
    btnGetZugm.Name := 'btnGetZugm';
    btnGetZugm.Left := 273;
    btnGetZugm.Top := 82;
    btnGetZugm.Width := 50;
    btnGetZugm.Height := 36;
    btnGetZugm.Cursor := crHandPoint;
    btnGetZugm.ParentDoubleBuffered := False;
    btnGetZugm.DoubleBuffered := True;
    btnGetZugm.Font.Charset := ANSI_CHARSET;
    btnGetZugm.Font.Color := clWindowText;
    btnGetZugm.Font.Height := -13;
    btnGetZugm.Font.Name := 'Verdana';
    btnGetZugm.Font.Style := [];
    btnGetZugm.ParentColor := True;
    btnGetZugm.TabOrder := 3;
    SetEvent(btnGetZugm, Self, 'OnClick', 'btnGetZugmClick');
    btnGetZugm.Text := '...';
    btnGetZugm.ControlIndex := 0;
    btnGetAnh.SetParentComponent(pnlFahrzeug);
    btnGetAnh.Name := 'btnGetAnh';
    btnGetAnh.Left := 274;
    btnGetAnh.Top := 158;
    btnGetAnh.Width := 50;
    btnGetAnh.Height := 40;
    btnGetAnh.Cursor := crHandPoint;
    btnGetAnh.ParentDoubleBuffered := False;
    btnGetAnh.DoubleBuffered := True;
    btnGetAnh.Font.Charset := ANSI_CHARSET;
    btnGetAnh.Font.Color := clWindowText;
    btnGetAnh.Font.Height := -13;
    btnGetAnh.Font.Name := 'Verdana';
    btnGetAnh.Font.Style := [];
    btnGetAnh.ParentColor := True;
    btnGetAnh.TabOrder := 4;
    SetEvent(btnGetAnh, Self, 'OnClick', 'btnGetAnhClick');
    btnGetAnh.Text := '...';
    btnGetAnh.ControlIndex := 0;
    edtDatum.SetParentComponent(pnlFahrzeug);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 97;
    edtDatum.Top := 33;
    edtDatum.Width := 131;
    edtDatum.Height := 28;
    edtDatum.Cursor := crHandPoint;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.ChildOrder := 5;
    edtDatum.Color := 16776441;
    edtDatum.Date := 45767.262767685180000000;
    edtDatum.ReadOnly := True;
    edtDatum.Role := '';
    edtDatum.ShowSeconds := False;
    edtDatum.Text := '';
    btnDelAnh.SetParentComponent(pnlFahrzeug);
    btnDelAnh.Name := 'btnDelAnh';
    btnDelAnh.Left := 327;
    btnDelAnh.Top := 158;
    btnDelAnh.Width := 50;
    btnDelAnh.Height := 40;
    btnDelAnh.Cursor := crHandPoint;
    btnDelAnh.ParentDoubleBuffered := False;
    btnDelAnh.DoubleBuffered := True;
    btnDelAnh.Font.Charset := ANSI_CHARSET;
    btnDelAnh.Font.Color := clWindowText;
    btnDelAnh.Font.Height := -13;
    btnDelAnh.Font.Name := 'Verdana';
    btnDelAnh.Font.Style := [];
    btnDelAnh.ParentColor := True;
    btnDelAnh.TabOrder := 6;
    SetEvent(btnDelAnh, Self, 'OnClick', 'btnDelAnhClick');
    btnDelAnh.Text := '';
    btnDelAnh.TextVisible := False;
    btnDelAnh.Bitmaps.Clear;
    with btnDelAnh.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnDelAnh.BitmapVisible := True;
    btnDelAnh.BitmapContainer := BitmapCont;
    btnDelAnh.ControlIndex := 0;
    tabSprachDaten.Left := 384;
    tabSprachDaten.Top := 400;
  finally
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbAbfKonCaption.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnPrev.AfterLoadDFMValues;
    pnlZusammenfassung.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    lbMaengel.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    aUnterschrift.AfterLoadDFMValues;
    optFahrbereit.AfterLoadDFMValues;
    optNichtFahrbereit.AfterLoadDFMValues;
    aTreeView.AfterLoadDFMValues;
    aBitmapContainerTreeView.AfterLoadDFMValues;
    pnlFahrzeug.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    edtZug.AfterLoadDFMValues;
    edtAnh.AfterLoadDFMValues;
    edtKmStand.AfterLoadDFMValues;
    btnGetZugm.AfterLoadDFMValues;
    btnGetAnh.AfterLoadDFMValues;
    edtDatum.AfterLoadDFMValues;
    btnDelAnh.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
